<template>
  <div class="transformer-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>U₁/U₂ = n₁/n₂ = I₂/I₁$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：变压器铁芯与线圈 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 铁芯 (闭合磁路) -->
            <rect x="100" y="50" width="200" height="120" rx="10" fill="none" stroke="#555" stroke-width="20" />
            
            <!-- 原线圈 -->
            <g transform="translate(100, 60)">
               <path v-for="i in primaryTurns" :key="'p'+i" 
                 :d="`M -10 ${i*5} Q 0 ${i*5+2} 10 ${i*5}`" 
                 fill="none" stroke="#ff4757" stroke-width="2" />
               <text x="-40" y="0" fill="#ff4757" font-size="9">n1 = {{ primaryTurns }}</text>
            </g>

            <!-- 副线圈 -->
            <g transform="translate(300, 60)">
               <path v-for="i in secondaryTurns" :key="'s'+i" 
                 :d="`M -10 ${i*5} Q 0 ${i*5+2} 10 ${i*5}`" 
                 fill="none" stroke="#00d2ff" stroke-width="2" />
               <text x="15" y="0" fill="#00d2ff" font-size="9">n2 = {{ secondaryTurns }}</text>
            </g>

            <!-- 磁通量示意 -->
            <ellipse v-if="powerOn" cx="200" cy="110" rx="85" ry="50" fill="none" stroke="#ffd700" stroke-width="1" stroke-dasharray="4,2">
               <animate attributeName="stroke-dashoffset" from="0" to="20" dur="1s" repeatCount="indefinite" />
            </ellipse>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>输出电压 U2</label>
               <span class="val">{{ outputV.toFixed(1) }} V</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>原线圈匝数 n1</label>
                  <el-slider v-model="primaryTurns" :min="10" :max="50" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>副线圈匝数 n2</label>
                  <el-slider v-model="secondaryTurns" :min="5" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>理想变压器利用<strong>互感现象</strong>工作。原线圈接入交流电产生变化的磁场，通过铁芯引导至副线圈产生感应电动势。电压比等于<strong>匝数比</strong>，而功率保持不变（不计损耗）。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransformerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      primaryTurns: 20,
      secondaryTurns: 40,
      inputV: 220,
      powerOn: true
    }
  },
  computed: {
    outputV() {
       return (this.secondaryTurns / this.primaryTurns) * this.inputV;
    }
  }
}
</script>

<style scoped lang="scss">
.transformer-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { font-family: monospace; color: #ff4757; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
